import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectCalendarState = (state: AppState) =>
	state.calendar;


export const selectCalendars = createSelector(
	selectCalendarState,
	(state) => state.calendars
);
export const selectCalendarAdded = createSelector(
	selectCalendarState,
	(state) => state.calendarAdded
);
export const selectCalendarAdding = createSelector(
	selectCalendarState,
	(state) => state.calendarAdding
);
export const selectCalendarEdited = createSelector(
	selectCalendarState,
	(state) => state.calendarEdited
);
export const selectCalendarEditing = createSelector(
	selectCalendarState,
	(state) => state.calendarEditing
);
export const selectExceptions = createSelector(
	selectCalendarState,
	(state) => state.exceptions
);
